import TotalProfitLossPage from "./total-profit-loss-page";

export default TotalProfitLossPage;
